export default __webpack_public_path__ + "static/assets/trainPointer.081c43875ac936fe3ec97bfc18be3df1.png";